(function () {
  'use strict'

  const MODULE_NAME = 'thismoment.embed.component.ugc'
  const templateUrl = require('./tpl/embed-ugc.html')

  require('./scss/embed-ugc.scss')
  require('dynamic-bind-html') // ಠ_ಠ

  require('angular')
    .module(MODULE_NAME, [
      require('../../../analytics'),
      require('../../../modal'),
      require('../../../common/filter/trustHtml'),
      require('../../../common/formly'),
      require('../../../common/formly/inputs/country-select'),
      require('../../../common/formly/inputs/datepicker'),
      require('../../../common/formly/inputs/file-upload'),
      require('../../../common/formly/inputs/html-checkbox'),
      require('../../../common/formly/inputs/html-read-only'),
      require('../../../common/formly/inputs/radio-required'),
      require('../../../common/formly/inputs/recaptcha'),
      require('../../../common/formly/inputs/state-select'),
      require('../../../common/formly/wrappers/required'),
      require('../../../common/formly/wrappers/settings-panel'),
      require('../../../common/formly/wrappers/validation'),
      require('../../provider/embed-ugc-api')
    ]).component('thismomentEmbedUgc', {
      templateUrl: templateUrl,
      bindings: {
        embedId: '=',
        embedName: '=',
        ready: '=',
        ariaLabel: '=',
        cancelBackgroundColor: '=',
        cancelColor: '=',
        cancelText: '=',
        errorButtonText: '=',
        errorColor: '=',
        errorDescription: '=',
        errorTitle: '=',
        fields: '<',
        processingDescription: '=',
        processingTitle: '=',
        submissionBackgroundColor: '=',
        submissionBackgroundImage: '=',
        submissionFormAutocomplete: '=',
        submissionFormDescription: '=',
        submissionFormDescriptionColor: '=',
        submissionFormTitle: '=',
        submissionFormTitleColor: '=',
        submitBackgroundColor: '=',
        submitColor: '=',
        submitText: '=',
        successButtonText: '=',
        successColor: '=',
        successDescription: '=',
        successTitle: '='
      },
      controller: embedUgcController
    })

  embedUgcController.$inject = ['$rootScope', '$scope', 'SdkConfig', 'analyticsSDK', 'EmbedUgcApi']
  function embedUgcController ($rootScope, $scope, SdkConfig, analyticsSDK, EmbedUgcApi) {
    var vm = this

    vm.$onInit = embedUgcInit

    function embedUgcInit () {
      // form states
      vm.busy = false
      vm.error = false
      vm.success = false

      // the form model
      vm.formData = {}

      vm.autocomplete = (vm.submissionFormAutocomplete) ? 'on' : 'off'

      // button functions
      vm.onSubmit = onSubmit
      vm.onReset = onReset
      vm.onRetry = onRetry

      // styles
      vm.styles = {}
      $scope.$watch('$ctrl.ready', (ready) => {
        if (!ready) {
          return
        }

        // styles
        if (vm.submissionFormDescription) {
          vm.styles.submissionFormDescription = {color: vm.submissionFormDescriptionColor}
        }
        if (vm.submissionFormTitle) {
          vm.styles.submissionFormTitle = {color: vm.submissionFormTitleColor}
        }
        if (vm.submissionBackgroundColor) {
          vm.styles.wrapper = {'background-color': vm.submissionBackgroundColor}
        }
        if (vm.submissionBackgroundImage) { vm.styles.wrapper['background-image'] = selectImage(vm.submissionBackgroundImage, 0)['background-image'] }
        if (vm.successColor) {
          vm.styles.success = {
            button: {
              'background-color': vm.successColor,
              'border-color': vm.successColor
            },
            glyph: {
              color: vm.successColor
            }
          }
        }
        if (vm.errorColor) {
          vm.styles.error = {
            button: {
              'background-color': vm.errorColor,
              'border-color': vm.errorColor
            },
            glyph: {
              color: vm.errorColor
            }
          }
        }

        // analytics
        vm.trackEvent = analyticsSDK.setupEventTracking({
          'embed title': vm.embedName,
          'embed type': 'ugc',
          'tm embed id': vm.embedId
        })
        vm.trackEvent('Embed Viewed', {
          'event trigger': 'loaded embed'
        })
      })
    }

    function onRetry () {
      // reset the form states & model
      vm.busy = false
      vm.success = false
      vm.ready = true
    }

    function onReset () {
      // reset the form states & model
      $scope.$applyAsync(function () {
        vm.formData = {}
        $rootScope.$broadcast('formly:resetForm')
        vm.error = false
        vm.busy = false
        vm.success = false
        vm.ready = true
      })
    }

    function onSubmit () {
      var analyticsProps = {
        'event trigger': 'submitted embed ugc'
      }
      for (var key in vm.formData) {
        if (key !== 'media') {
          // analyticsProps['form data ' + key] = vm.formData[key]
        }
      }
      vm.trackEvent('Embed Converted', analyticsProps)

      vm.busy = true
      EmbedUgcApi.post(SdkConfig.get('embed_id'), SdkConfig.get('account_id'), SdkConfig.get('group_id'), vm.formData).then((response) => {
        vm.busy = false
        vm.success = true
      }).catch(function (error) {
        vm.busy = false
        vm.error = true
        console.warn(error)
      })
    }

    function selectImage (data, height) {
      if (data === null) {
        return data
      }
      var obj = JSON.parse(data)
      var img = obj.metadata.images.original
      var max = height - 10
      var imgHeight = img.height
      var styles = {
        'background-image': 'url(' + obj.orig_file + ')',
        height: max + 'px'
      }

      if (imgHeight > max) {
        var ratio = max / imgHeight
        styles.width = Math.ceil(img.width * ratio) + 'px'
      } else {
        styles.width = img.width + 'px'
      }

      return styles
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/embed/component/embed-ugc/index.js